import { Box, BoxProps, Icon, ModBox, Text, TextProps } from '@jfs/ui-new'
import React from 'react'
import ReactDOM from 'react-dom'
import { Dimensions, View, ViewStyle } from 'react-native'

interface TooltipViewProps {
  value: any
  top: number
}

const Tooltip = ({ toolTipInfo, value }: any) => {
  const width = Dimensions.get('window').width
  const left = width - toolTipInfo.left < 100 ? toolTipInfo.left - 120 : toolTipInfo.left
  const style = {
    marginLeft: width - toolTipInfo.left < 100 ? 128 : 10,
  }
  return (
    <Box top={toolTipInfo.top} left={left} position={'absolute'} maxWidth={150} zIndex={1}>
      <Box bg={'BLACK'} borderRadius={4} p={4}>
        <Text {...styles.text}>{`Original data: ${value?.originalData}`}</Text>
        <Text {...styles.text}>{`Maker: ${value?.maker}`}</Text>
        <Text {...styles.text}>{`Updated on: ${value?.updatedOn}`}</Text>
      </Box>
      <View style={[styles.triangle, style]} />
    </Box>
  )
}

const ToolTipView = ({ value, top }: TooltipViewProps) => {
  const [toolTipInfo, setToolTipInfo] = React.useState({ visible: false, top: 0, right: 0, left: 0 })
  const [layoutEvent, setLayoutEvent] = React.useState<any>({})

  const renderTooltip = () => {
    return <Tooltip toolTipInfo={toolTipInfo} value={value} />
  }
  return (
    <>
      <Box
        paddingLeft={6}
        underlayColor="TRANSPARENT"
        onLayout={(event: any) => {
          console.log('ToolTipView event', event.nativeEvent.layout)
          setLayoutEvent(event.nativeEvent)
          setToolTipInfo({
            ...toolTipInfo,
            top: event.nativeEvent.layout?.top + 15,
            left: event.nativeEvent.layout?.left,
          })
        }}
        onHover={(hovered: any) => {
          layoutEvent?.target?.measure((...args: any) => {
            setToolTipInfo({ ...{ ...toolTipInfo, top: args[5] + top - 50, left: args[4] }, visible: hovered })
          })
        }}
        onPress={() => {
          setToolTipInfo({ ...toolTipInfo, visible: !toolTipInfo.visible })
        }}>
        <Icon id="INFO" size={16} color="ORANGE" />
      </Box>
      <ModBox show={toolTipInfo.visible} position="absolute">
        {ReactDOM.createPortal(renderTooltip(), document.body)}
      </ModBox>
    </>
  )
}

const styles = {
  shadowStyle: {
    position: 'absolute',
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 2,
    shadowColor: 'GREY_MATTE',
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: 'BRAND_COLOR_GRAY_3',
    zIndex: 5,
    backgroundColor: 'WHITE',
    padding: 16,
  } as BoxProps,
  text: {
    fontSize: 10,
    color: 'WHITE',
    fontFamily: 'jiotype-medium',
    includeFontPadding: true,
  } as TextProps,
  triangle: {
    width: 0,
    height: 0,
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    borderColor: 'blue',
    borderLeftWidth: 4,
    borderRightWidth: 4,
    borderBottomWidth: 4,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: 'BLACK_21',
    marginLeft: 4,
    transform: [{ rotate: '180deg' }],
  } as ViewStyle,
}

export { ToolTipView }
